import keyBy from 'lodash/keyBy';

import {
	StoreAsyncItem,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction,
	invalidateStateFromAction
} from '../../../flux';
import { integrationsActionsPack } from '../actions';


export interface IIntegrationsState {
	cms: StoreAsyncItem<Record<string, CashManagementSystem>>;
	externalSystemAccounts: StoreAsyncItem<Record<string, ExternalSystemAccount>>;
	externalSubsystemInstances: StoreAsyncItem<Record<string, SubsystemInstance>>;
	remoteExternalServices: StoreAsyncItem<Record<string, RemoteExternalService>>;
};

const initialState: IIntegrationsState = {
	cms: createAsyncInitialState<Record<string, CashManagementSystem>>(),
	externalSystemAccounts:  createAsyncInitialState<Record<string, ExternalSystemAccount>>(),
	externalSubsystemInstances: createAsyncInitialState<Record<string, SubsystemInstance>>(),
	remoteExternalServices: createAsyncInitialState<Record<string, RemoteExternalService>>(),
};

const integrationsReducer = createReducer(initialState, {
	[integrationsActionsPack.types.FETCH_CASH_MANAGEMENT_SYSTEMS]: (action, state) => {
		return {
			cms: checkAsyncAction<Array<CashManagementSystem>>(action, state.cms, item => keyBy(item, item => item.ID))
		};
	},
	[integrationsActionsPack.types.FETCH_EXTERNAL_SYSTEM_ACCOUNTS]: (action, state) => {
		return {
			externalSystemAccounts: checkAsyncAction<Array<ExternalSystemAccount>>(action, state.externalSystemAccounts, item => keyBy(item, item => item.ID))
		};
	},
	[integrationsActionsPack.types.FETCH_TENANT_INTEGRATIONS_DATA]: (action, state) => {
		return {
			externalSubsystemInstances: checkAsyncAction<{ssInstanceList: Array<SubsystemInstance>}>(action, state.externalSubsystemInstances, item => keyBy(item.ssInstanceList, item => item.GUID)),
			remoteExternalServices: checkAsyncAction<{remoteExternalServiceMap: Record<string, RemoteExternalService>}>(action, state.externalSubsystemInstances, item => item.remoteExternalServiceMap),
		};
	},
	[integrationsActionsPack.types.ADD_EXTERNAL_SYSTEM_ACCOUNT]: (action, state) => {
		return {
			externalSystemAccounts: invalidateStateFromAction(action, state.externalSystemAccounts),
			externalSubsystemInstances: invalidateStateFromAction(action, state.externalSubsystemInstances),
			remoteExternalServices: invalidateStateFromAction(action, state.remoteExternalServices),
		};
	},
	[integrationsActionsPack.types.CHANGE_EXTERNAL_SYSTEM_ACCOUNT]: (action, state) => {
		return {
			externalSystemAccounts: invalidateStateFromAction(action, state.externalSystemAccounts),
			externalSubsystemInstances: invalidateStateFromAction(action, state.externalSubsystemInstances),
			remoteExternalServices: invalidateStateFromAction(action, state.remoteExternalServices),
		};
	},
	[integrationsActionsPack.types.REMOVE_EXTERNAL_SYSTEM_ACCOUNT]: (action, state) => {
		return {
			externalSystemAccounts: invalidateStateFromAction(action, state.externalSystemAccounts),
			externalSubsystemInstances: invalidateStateFromAction(action, state.externalSubsystemInstances),
			remoteExternalServices: invalidateStateFromAction(action, state.remoteExternalServices),
		};
	},
});

export default integrationsReducer;
